<template>
    <div class="desktop-only flex">
        <ui-dropdown menu-class="p-3 w-72" :close-on-mouse-out-scroll="true">
            <template #default="{ toggle }">
                <button @click="() => {toggle()}"
                        class="text-gray-300 mt-1 focus:outline-none w-10">
                    <img :src="avatar"
                         class="rounded rounded-full" style="height:40px;width:40px;"/>
                </button>
            </template>
            <template #menu="{ close }">
                <ui-dropdown-item icon="fa fa-user" v-if="profile" @click="goProfile()">
                    User Profile
                </ui-dropdown-item>
                <ui-dropdown-divider v-if="profile"></ui-dropdown-divider>
                <ui-dropdown-item icon="far fa-building"
                                  :ticked="currentContext && (currentContext.organizationId === org.id)"
                                  v-for="(org,index) in user.memberOf" :key='index' @click="switchOrganization(org)">
                    {{ org.name }}
                </ui-dropdown-item>
            </template>
        </ui-dropdown>
    </div>
</template>

<script>

import UiDropdownItem from "../../ui/UiDropdownItem.vue";
import UiDropdownDivider from "../../ui/UiDropdownDivider.vue";
import User from "../../../services/User";

export default {
    components: {UiDropdownDivider, UiDropdownItem},
    props: {
        profile: {type: Boolean, default: true},
        defaultAvatar: {type: String, default: ""},
    },
    data() {
        return {
            profileRoute: route('mobile.profile'),
            user: User,
            currentContext: null,
            avatar: this.defaultAvatar,
        }
    },
    computed: {},
    methods: {
        async switchOrganization(org) {
            await User.switchOrganization(org.id);
        },
        goProfile() {
            window.location.href = this.profileRoute;
        },
        updateUserFromListener(e) {
            if (User.user.avatarUrl) {
                this.avatar = User.user.avatarUrl
            }
        }
    },
    async mounted() {
        await User.register()
        this.user = User.user
        this.updateUserFromListener()
        User.registerAggregate({"type": 'User', 'id': this.user.id}, this.updateUserFromListener)
        this.currentContext = User.getUserObject().context
    }
}
</script>
